import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { machineryService } from '../../../services/machineryService';
import Toast from '../../../components/Common/Toast';

const CreateHourMeter = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [machines, setMachines] = useState([]);
  const [toast, setToast] = useState({ isOpen: false, message: '', type: 'info' });
  const [formData, setFormData] = useState({
    machine_id: '',
    reading_date: new Date().toISOString().split('T')[0],
    hours: '',
    previous_hours: '',
    operator: '',
    notes: ''
  });

  useEffect(() => {
    loadMachines();
  }, []);

  const loadMachines = async () => {
    try {
      const response = await machineryService.getMachines();
      if (response.success) setMachines(response.data);
    } catch (error) {
      setToast({ isOpen: true, message: 'Error al cargar máquinas', type: 'error' });
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.machine_id) {
      setToast({ isOpen: true, message: 'Debe seleccionar una máquina', type: 'error' });
      return;
    }
    setLoading(true);
    try {
      const machine = machines.find(m => m.id === parseInt(formData.machine_id));
      const data = {
        machine_id: parseInt(formData.machine_id),
        machine_code: machine?.code || '',
        machine_name: machine?.name || '',
        reading_date: formData.reading_date,
        hours: parseFloat(formData.hours) || 0,
        previous_hours: parseFloat(formData.previous_hours) || 0,
        hours_difference: (parseFloat(formData.hours) || 0) - (parseFloat(formData.previous_hours) || 0),
        operator: formData.operator,
        notes: formData.notes
      };
      const response = await machineryService.createHourMeter(data);
      if (response.success) {
        setToast({ isOpen: true, message: 'Registro de horómetro creado exitosamente', type: 'success' });
        setTimeout(() => navigate('/machinery/hour-meters'), 1500);
      } else {
        setToast({ isOpen: true, message: response.message || 'Error al crear', type: 'error' });
      }
    } catch (error) {
      setToast({ isOpen: true, message: 'Error al crear el registro', type: 'error' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-6">
      <div className="max-w-2xl mx-auto">
        <div className="mb-6">
          <h1 className="text-3xl font-bold text-gray-800">Nuevo Registro de Horómetro</h1>
          <p className="text-gray-600 mt-1">Registre las horas de operación de una máquina</p>
        </div>
        <form onSubmit={handleSubmit} className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
          <div className="space-y-6">
            <div><label className="block text-sm font-medium text-gray-700 mb-2">Máquina *</label>
              <select name="machine_id" value={formData.machine_id} onChange={handleChange} required className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500">
                <option value="">Seleccione una máquina</option>
                {machines.map(m => <option key={m.id} value={m.id}>{m.code} - {m.name}</option>)}
              </select>
            </div>
            <div><label className="block text-sm font-medium text-gray-700 mb-2">Fecha de Lectura *</label>
              <input type="date" name="reading_date" value={formData.reading_date} onChange={handleChange} required className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500" />
            </div>
            <div><label className="block text-sm font-medium text-gray-700 mb-2">Horas Anteriores</label>
              <input type="number" name="previous_hours" value={formData.previous_hours} onChange={handleChange} step="0.1" className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500" />
            </div>
            <div><label className="block text-sm font-medium text-gray-700 mb-2">Horas Actuales *</label>
              <input type="number" name="hours" value={formData.hours} onChange={handleChange} step="0.1" required className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500" />
            </div>
            <div><label className="block text-sm font-medium text-gray-700 mb-2">Operador</label>
              <input type="text" name="operator" value={formData.operator} onChange={handleChange} className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500" />
            </div>
            <div><label className="block text-sm font-medium text-gray-700 mb-2">Notas</label>
              <textarea name="notes" value={formData.notes} onChange={handleChange} rows="3" className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500" />
            </div>
          </div>
          <div className="mt-6 flex gap-4">
            <button type="submit" disabled={loading} className="px-6 py-2.5 bg-teal-600 hover:bg-teal-700 disabled:bg-gray-400 text-white rounded-lg font-medium transition-colors">
              {loading ? 'Guardando...' : 'Guardar'}
            </button>
            <button type="button" onClick={() => navigate('/machinery/hour-meters')} className="px-6 py-2.5 bg-gray-200 hover:bg-gray-300 text-gray-700 rounded-lg font-medium transition-colors">
              Cancelar
            </button>
          </div>
        </form>
      </div>
      <Toast isOpen={toast.isOpen} message={toast.message} type={toast.type} onClose={() => setToast({ ...toast, isOpen: false })} />
    </div>
  );
};

export default CreateHourMeter;
